import * as Sentry from "@sentry/astro";

// When this file exists, @sentry/astro injects it instead of generating a client
// init from the options in astro.config.mjs, so the defaults it would have emitted
// (tracing, replay, sample rates) have to be repeated here. The `enabled` option in
// astro.config.mjs still gates whether this file is injected at all.
Sentry.init({
  dsn: "https://23c99ac785fdc0eed5044cee3a4b05ea@o296138.ingest.us.sentry.io/4507965578149888",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    // Chrome on Android aborts the View Transition that Astro's ClientRouter starts
    // on the first client-side navigation. The navigation itself completes; only the
    // transition promise rejects, and it surfaces as an unhandled rejection.
    // https://github.com/withastro/astro/issues/10830
    /Transition was aborted because of invalid state/,
  ],
});
